export default "__VITE_ASSET__ytI10ilu__"